/**
 * Format a time to be understable for the user.
 */
export const prettyTime = (
  time: string | null | undefined
): string | undefined => time?.replace(/(\d+:\d+)(:0+|:0+\.0+|\.0+)$/, '$1');
